export default {
    COMUM: {
        BUSCAR_DADOS_USUARIO_AUTENTICADO: 'buscarDadosDoUsuarioAutenticado',
    },
    USUARIO: {
        BUSCAR_TODOS_USUARIOS: 'buscarTodosUsuarios',
        CADASTRAR_USUARIO: 'cadastrarUsuario',
        EDITAR_USUARIO: 'editarUsuario',
        BUSCAR_USUARIO_POR_ID: 'buscarUsuarioPorId',
        BUSCAR_AVATARES: 'buscarAvatares',
        ATUALIZAR_FOTO_AVATAR: 'atualizarFotoAvatar',
        SELECIONAR_FOTO_AVATAR: 'selecionarFotoAvatar',
    },
    PERFIL: {
        BUSCAR_TODOS_PERFIS: 'buscarTodosPerfis',
        CADASTRAR_PERFIL: 'cadastrarPerfil',
        EDITAR_PERFIL: 'editarPerfil',
        BUSCAR_PERFIL_POR_ID: 'buscarPerfilPorId',
        REMOVER_PERFIL: 'removerPerfil'
    },
    PERFIL_USUARIO: {
        BUSCAR_PERFIS_DO_USUARIO: 'buscarPerfisDoUsuario',
        ATUALIZAR_PERFIS_DO_USUARIO: 'atualizarPerfisDoUsuario'
    },
    PERFIL_PERMISSAO: {
        BUSCAR_POR_PERFIL: 'buscarPorPerfil',
        CADASTRAR_PERMISSAO: 'cadastrarPermissao',
        EDITAR_PERMISSAO: 'editarPermissao',
        REMOVER_PERMISSAO: 'removerPermissao'
    },
    ROTULOS_PERSONALIZADOS: {
        GET_ALL_ROTULOS_PERSONALIZADOS: 'getAllRotulosPersonlizados',
    },
    COBRANCA: {
        BUSCAR_TODAS_COBRANCAS: 'buscarTodasCobrancas',
        BUSCAR_TODAS_COBRANCAS_INTERNO: 'buscarTodasCobrancasInterno',
        BUSCAR_TODAS_COBRANCAS_ATENDIMENTO: 'buscarTodasCobrancasAtendimento',
        CADASTRAR_COBRANCA: 'cadastrarCobranca',
        EDITAR_COBRANCA: 'editarCobranca',
        EXCLUIR_COBRANCA: 'excluirCobranca',
        BUSCAR_COBRANCA_POR_ID: 'buscarCobrancaPorId',
        ESTORNAR_COBRANCA: 'estornarCobranca',
        CANCELAR_COBRANCA: 'cancelarCobranca'
    },
    ORCAMENTO: {
        BUSCAR_TODOS_ORCAMENTOS: 'buscarTodosOrcamentos',
        CADASTRAR_ORCAMENTOS: 'cadastrarOrcamento',
        EDITAR_ORCAMENTOS: 'editarOrcamento',
        EXCLUIR_ORCAMENTOS: 'excluirOrcamento',
        ATUALIZAR_STATUS: 'atualizarStatus'
    },
    SERVICO: {
        BUSCAR_TODOS_SERVICOS: 'buscarTodosServicos',
        CADASTRAR_SERVICO: 'cadastrarServico',
        EDITAR_SERVICO: 'editarServico',
        EXCLUIR_SERVICO: 'excluirServico',
    },
    SERVICO_ATENDIMENTO: {
        CADASTRAR_SERVICO: 'cadastrarServicoAtendimento',
        EDITAR_SERVICO: 'editarServicoAtendimento',
        EXCLUIR_SERVICO: 'excluirServicoAtendimento',
        BUSCAR_TODOS_SERVICOS: 'buscarTodosServicosAtendimento',
    },
    SERVICO_ORCAMENTO: {
        CADASTRAR_SERVICO: 'cadastrarServicoOrcamento',
        EDITAR_SERVICO: 'editarServicoOrcamento',
        EXCLUIR_SERVICO: 'excluirServicoOrcamento',
        BUSCAR_TODOS_SERVICOS: 'buscarTodosServicosOrcamento',
    },
    GALERIA_PACIENTE: {
        ENVIAR_MIDIA_PACIENTE: 'enviarMidiaPaciente',
        BUSCAR_MIDIAS_PACIENTE: 'buscarMidiasPaciente',
        REMOVER_MIDIA_PACIENTE: 'removerMidiaPaciente',
        GERAR_TOKEN_QR_CODE: 'gerarTokenQrCode',
        ENVIAR_MIDIA_PUBLIC_TOKEN: 'enviarMidiaPublicToken',
    },
    CADASTROS: {
        PACIENTE: {
            BUSCAR_TODOS_PACIENTES_SEM_PAGINACAO: 'buscarTodosPacientesSemPaginacao',
            BUSCAR_TODOS_PACIENTES: 'buscarTodosPacientes',
            CADASTRAR_PACIENTE: 'cadastrarPaciente',
            EDITAR_PACIENTE: 'editarPaciente',
            EXCLUIR_PACIENTE: 'excluirPaciente',
            BUSCAR_PACIENTE_POR_ID: 'buscarPacientePorId',
            VALIDAR_DOCUMENTO_JA_CADASTRADO: 'validarDocumentoJaCadastrado',
            FICHA: {
                CADASTRAR_FICHA: 'cadastrarFicha',
                EDITAR_FICHA: 'editarFicha',
                BUSCAR_POR_PACIENTE: 'buscarPorPaciente'
            }
        },
        CIDADE: {
            BUSCAR_TODAS_CIDADES: 'buscarTodasCidades',
            BUSCAR_TODAS_CIDADES_SEM_PAGINACAO: 'buscarTodasCidadesSemPaginacao',
            CADASTRAR_CIDADE: 'cadastrarCidade',
            EDITAR_CIDADE: 'editarCidade',
            EXCLUIR_CIDADE: 'excluirCidade',
            BUSCAR_CIDADE_POR_ID: 'buscarCidadePorId'
        },
        ESTADO: {
            BUSCAR_TODOS_ESTADOS_SEM_PAGINACAO: 'buscarTodosEstadosSemPaginacao'
        },
    },
    RELATORIOS: {
        GERAR_RELATORIO_FICHA_PACIENTE: 'gerarRelatorioFichaPaciente',
        GERAR_RELATORIO_COBRANCA: 'gerarRelatorioCobranca',
        GERAR_RELATORIO_PACIENTES: 'gerarRelatorioPacientes',
        GERAR_RELATORIO_ORCAMENTOS: 'gerarRelatorioOrcamentos',
        GERAR_RELATORIO_PAGAMENTOS: 'gerarRelatorioPagamentos',
        GERAR_RELATORIO_ORCAMENTO_FINALIZADO: 'gerarRelatorioOrcamentoFinalizado'
    },
    PAGAMENTO: {
        CADASTRAR_PAGAMENTO: 'cadastrarPagamento',
        EDITAR_PAGAMENTO: 'editarPagamento',
        EXCLUIR_PAGAMENTO: 'excluirPagamento',
        BUSCAR_PAGAMENTOS_POR_COBRANCA_ID: 'buscarPagamentosPorCobrancaId',
    },
    SALA_ESPERA: {
        ADICIONAR_PACIENTE: 'adicionarPaciente',
        BUSCAR_DADOS: 'buscarDados',
        REMOVER_SALA_ESPERA: 'removerSalaEspera'
    },
    AGENDA: {
        BUSCAR_DENTISTAS: 'buscarDentistas',
        BUSCAR_EVENTOS: 'buscarEventos',
        ADICIONAR_EVENTO: 'adicionarEvento',
        REMOVER_EVENTO: 'removerEvento',
        EDITAR_EVENTO: 'editarEvento',
        EDITAR_DETALHES_DENTISTA: 'editarDetalhesDentista',
        BUSCAR_TODOS_DENTISTAS_SEM_PAGINACAO: 'buscarTodosDentistasSemPaginacao',
    },
    ATENDIMENTO: {
        BUSCAR_ATENDIMENTOS_PACIENTE: 'buscarAtendimentosPaciente',
        BUSCAR_ATENDIMENTO_POR_ID: 'buscarAtendimentoPorId',
        AGENDAR_ATENDIMENTO: 'agendarAtendimento',
        INICIAR_ATENDIMENTO: 'iniciarAtendimento',
        CANCELAR_ATENDIMENTO: 'cancelarAtendimento',
        REMOVER_ATENDIMENTO: 'removerAtendimento',
        FINALIZAR_ATENDIMENTO: 'finalizarAtendimento',
        ATUALIZAR_ATENDIMENTO_PACIENTE: 'atualizarAtendimentoPaciente',
        INSERIR_PROCEDIMENTO: 'inserirProcedimento',
        ATUALIZAR_PROCEDIMENTO: 'atualizarProcedimento',
        REMOVER_PROCEDIMENTO: 'removerProcedimento',
        BUSCAR_HISTORICO_PROCEDIMENTO: 'buscarHistoricoProcedimento',
    },
    FILE_MANAGER: {
        UPLOAD_ARQUIVO: 'uploadArquivo',
        BAIXAR_ARQUIVO: 'baixarArquivo',
    },
    ODONTOGRAMA: {
        BUSCAR_ODONTOGRAMA: 'buscarOdontograma',
    },
    PARAMETROS: {
        INSERIR_CONFIGURACAO: 'inserirConfiguracao',
        ATUALIZAR_CONFIGURACAO: 'atualizarConfiguracao',
        DELETAR_CONFIGURACAO: 'deletarConfiguracao',
        BUSCAR_PARAMETROS_CONFIGURACAO: 'buscarParametrosConfiguracao',
        BUSCAR_CONFIGURACOES_SISTEMA: 'buscarConfiguracoesSistema'
    },
    INICIO: {
        DASHBOARD: 'dashboard',
        BUSCAR_PACIENTES_AGENDADOS: 'buscarPacientesAgendados',
    }
}
